import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export interface DefaultPhotoRequirement {
  id: string;
  createdById: string;
  name: string;
  isRequired: boolean;
  order: number;
  timestamps: {
    createdAt: string;
    updatedAt: string;
  };
}

export const defaultPhotoRequirementsQueryAtom = createQueryAtomFactory(
  'trade.defaultPhotoRequirements',
  () => ({
    defaultPhotoRequirements: {
      id: true,
      createdById: true,
      name: true,
      isRequired: true,
      order: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  {
    select: (data) => data?.defaultPhotoRequirements ?? [],
  },
);
